import { faMoneyBill } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Card, CardHeader, Typography, useTheme } from "@material-ui/core";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { UsersData } from "src/ContextAPI";
import Notify from "src/notification/Notify";
import IsMountedRef from "src/utils/IsMountedRef";

const GrandCardExpense = () => {
  const { users } = useContext(UsersData);
  const mounted = IsMountedRef();
  const [grandExpense, setGrandExpense] = useState(0);
  const theme = useTheme();

  const getAllExpenses = React.useCallback(async () => {
    let response = await axios.get("accounting/grand/expense-totalamount", {
      params: {
        main_mgmt_id: users.main_mgmt_id,
      },
    });

    if (mounted.current) {
      if (response.data.length > 0) {
        calculateTotal(response.data);
      }
    }
  }, [mounted, users]);

  const calculateTotal = (data) => {
    let x = 0;

    data.forEach((element) => {
      x += parseFloat(element.totalExpense);
    });

    setGrandExpense(x);
  };

  useEffect(() => {
    getAllExpenses();
  }, [getAllExpenses]);

  return (
    <Card elevation={5}>
      <CardHeader
        avatar={
          <FontAwesomeIcon
            icon={faMoneyBill}
            size={"5x"}
            style={{ color: `${theme.palette.primary.main}` }}
          />
        }
        title={
          <Typography variant="h4" color="textSecondary" noWrap>
            Expenses
          </Typography>
        }
        // subheader={
        //   <Typography variant="h5">
        //     <strong> &#8369; {Notify.convertToNumber(grandExpense)} </strong>
        //   </Typography>
        // }
      />
      <Box mb={2}>
        <Typography variant="h4" align="center">
          <strong> &#8369; {Notify.convertToNumber(grandExpense)} </strong>
        </Typography>
      </Box>
    </Card>
  );
};

export default GrandCardExpense;
